import Brand from "./Brand";
import sbrFooterCss from "../styles/sbr-footer.css?raw";

export default function SbrFooter({ brand, isHomepage = false }) {
  const featuresHref = isHomepage ? "#features" : "/#features";
  // The homepage keeps its in-page jump; every other route goes to the real
  // crawlable /pricing page rather than bouncing through the homepage anchor.
  const pricingHref = isHomepage ? "#pricing" : "/pricing";

  return (
    <>
      <style>{sbrFooterCss}</style>
      <footer className="sbr-footer">
        <div className="wrap">
          <div className="sbr-footer-top">
            <Brand brand={brand} light />
            <nav className="sbr-footer-nav" aria-label="Footer">
              <div className="sbr-footer-col">
                <span className="sbr-footer-label">Reports</span>
                <a href={featuresHref}>What&apos;s included</a>
                <a href={pricingHref}>Pricing</a>
                {brand.guides?.length > 0 && <a href="/guides/">Guides</a>}
              </div>
              <div className="sbr-footer-col">
                <span className="sbr-footer-label">Free tools</span>
                <a href="/car-tax-calculator/">Road tax check</a>
                <a href="/ulez-checker">ULEZ checker</a>
                <a href="/insurance-groups">Insurance group</a>
                <a href="/free-car-check">Free car check</a>
                <a href="/vehicle-check">Tax and MOT check</a>
              </div>
              <div className="sbr-footer-col">
                <span className="sbr-footer-label">Company</span>
                <a href="/about">About</a>
                <a href="/contact">Contact</a>
                <a href="/terms">Terms</a>
                <a href="/privacy">Privacy</a>
              </div>
            </nav>
          </div>
          <div className="sbr-footer-bottom">
            <span>© 2026 {brand.name}. All rights reserved.</span>
            <span>Vehicle data comes from trusted third parties. {brand.name} is independent and unaffiliated with DVLA or DVSA.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
